import { colors } from 'src/theme'

export enum ContractorStepDetailsCardStatus {
  NotStarted = 'not_started',
  InProgress = 'in_progress',
  WaitingForApproval = 'waiting_for_approval',
  Pending = 'pending',
  Approved = 'approved',
  Failed = 'failed',
  Declined = 'declined',
  Expired = 'expired',
  ExpiringSoon = 'expiring_soon',
  Recollect = 'recollect',
  AbortRecollection = 'abort_recollection',
  Skipped = 'skipped',
}

export enum ContractorStepDetailsCardVariant {
  Default = 'default',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export enum ContractorStepDetailsCardUsageVariant {
  Contractor = 'contractor',
  MasterContractor = 'masterContractor',
}

export const CARD_BORDER_COLOR = colors.SHADES_GREY_200
export const CARD_BG = colors.GRAY_WHITE
export const METADATA_LABEL_COLOR = colors.SHADES_GREY_400

export const statusLabels: Record<ContractorStepDetailsCardStatus, string> = {
  [ContractorStepDetailsCardStatus.NotStarted]: 'Not Started',
  [ContractorStepDetailsCardStatus.InProgress]: 'In progress',
  [ContractorStepDetailsCardStatus.WaitingForApproval]: 'Waiting for approval',
  [ContractorStepDetailsCardStatus.Pending]: 'Pending',
  [ContractorStepDetailsCardStatus.Approved]: 'Approved',
  [ContractorStepDetailsCardStatus.Failed]: 'Failed',
  [ContractorStepDetailsCardStatus.Declined]: 'Declined',
  [ContractorStepDetailsCardStatus.Expired]: 'Expired',
  [ContractorStepDetailsCardStatus.ExpiringSoon]: 'Expiring soon',
  [ContractorStepDetailsCardStatus.Recollect]: 'Recollect',
  [ContractorStepDetailsCardStatus.AbortRecollection]: 'Abort Recollection',
  [ContractorStepDetailsCardStatus.Skipped]: 'Skipped',
}

export const customerStatusLabels: Partial<Record<ContractorStepDetailsCardStatus, string>> = {
  [ContractorStepDetailsCardStatus.NotStarted]: 'Not Started',
  [ContractorStepDetailsCardStatus.InProgress]: 'In progress',
  [ContractorStepDetailsCardStatus.Pending]: 'Pending',
  [ContractorStepDetailsCardStatus.Approved]: 'Approved',
  [ContractorStepDetailsCardStatus.Failed]: 'Failed',
  [ContractorStepDetailsCardStatus.Expired]: 'Expired',
}

export const masterContractorStatusLabels = customerStatusLabels

export const statusToVariant: Record<
  ContractorStepDetailsCardStatus,
  ContractorStepDetailsCardVariant
> = {
  [ContractorStepDetailsCardStatus.NotStarted]: ContractorStepDetailsCardVariant.Default,
  [ContractorStepDetailsCardStatus.InProgress]: ContractorStepDetailsCardVariant.Info,
  [ContractorStepDetailsCardStatus.WaitingForApproval]: ContractorStepDetailsCardVariant.Warning,
  [ContractorStepDetailsCardStatus.Pending]: ContractorStepDetailsCardVariant.Default,
  [ContractorStepDetailsCardStatus.Approved]: ContractorStepDetailsCardVariant.Success,
  [ContractorStepDetailsCardStatus.Failed]: ContractorStepDetailsCardVariant.Error,
  [ContractorStepDetailsCardStatus.Declined]: ContractorStepDetailsCardVariant.Error,
  [ContractorStepDetailsCardStatus.Expired]: ContractorStepDetailsCardVariant.Error,
  [ContractorStepDetailsCardStatus.ExpiringSoon]: ContractorStepDetailsCardVariant.Warning,
  [ContractorStepDetailsCardStatus.Recollect]: ContractorStepDetailsCardVariant.Warning,
  [ContractorStepDetailsCardStatus.AbortRecollection]: ContractorStepDetailsCardVariant.Default,
  [ContractorStepDetailsCardStatus.Skipped]: ContractorStepDetailsCardVariant.Success,
}

export const variantStyles: Record<ContractorStepDetailsCardVariant, { bg: string; text: string }> =
  {
    [ContractorStepDetailsCardVariant.Default]: {
      bg: colors.SHADES_GREY_200,
      text: colors.SHADES_GREY_500,
    },
    [ContractorStepDetailsCardVariant.Info]: {
      bg: colors.COLORS_BLUE_200,
      text: colors.COLORS_BLUE_500,
    },
    [ContractorStepDetailsCardVariant.Success]: {
      bg: colors.COLORS_GREEN_200,
      text: colors.COLORS_GREEN_500,
    },
    [ContractorStepDetailsCardVariant.Warning]: {
      bg: colors.COLORS_ORANGE_200,
      text: colors.COLORS_ORANGE_500,
    },
    [ContractorStepDetailsCardVariant.Error]: {
      bg: colors.COLORS_RED_50,
      text: colors.COLORS_RED_500,
    },
  }

export const EXPIRING_SOON_LABEL = 'Expires soon'

export const DECLINED_STATUS_LABEL = 'Declined (Contractor Notified to Re-Upload)'
